import React from 'react';
import clsx from 'clsx';
import { FormControlLabel, Radio, RadioGroup, withStyles } from '@material-ui/core';

const styles = theme => ({
    radioContainer: {
        display: 'inline',
        marginLeft: '3px'
    },
    checkBox: {
        paddingLeft: 18,
        color: "#6EA0D7"
    },
})

const RadioButtons = (props) => {
    let { classes, radioGroupClass, formControlClass, name, value, onChange, extraOnChange, radios, disabled = false } = props;

    return (
        <RadioGroup className={clsx(classes.radioContainer, radioGroupClass)} name={name} value={value} onChange={(e) =>
            onChange(e, extraOnChange)
        }>
            {radios.map(
                radio => <FormControlLabel
                    className={formControlClass}
                    control={<Radio className={clsx(radio.classes)} color={'primary'} />}
                    label={radio.label}
                    value={radio.value}
                    labelPlacement={radio.labelPlacement}
                    disabled={disabled}
                />
            )}
        </RadioGroup>
    )
};

export default withStyles(styles)(RadioButtons);